export default "__VITE_PUBLIC_ASSET__8fc0ff0c__"